import { render, staticRenderFns } from "./shop_info.vue?vue&type=template&id=6ce7c741&scoped=true&"
import script from "./shop_info.vue?vue&type=script&lang=tsx&"
export * from "./shop_info.vue?vue&type=script&lang=tsx&"
import style0 from "./shop_info.vue?vue&type=style&index=0&id=6ce7c741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7c741",
  null
  
)

export default component.exports